const BIXGROW_API_URL = "https://api.bixgrow.com/api";
const BASE_TRACK_URL = "https://track.bixgrow.com/api";

var bgPopupData = null;

document.addEventListener("DOMContentLoaded", async function () {
  const payload = {
    shop: Shopify.shop
  }

  bgUseFetch(`${BIXGROW_API_URL}/shop/custom-popup/data`,'GET',payload).then(data => {
    if(data){
        bgPopupData = data;
        bgInitPopup(bgPopupData);
    }
  })

});

function bgInitPopup(data) {
  applyStyles();

  const popupHTML = `
        <div id="bg-popup-container" class="bg-popup-container" style="${data.button.position == 'left' ?'left: 20px;':'right:20px'}">
            <button id="bg-poup-button" class="bg-popup-button"  style="background-color: ${data.button.backgroundColor}; color: ${data.button.textColor}" onclick="togglePopup()">
              <span class="bg-popup-button__text">${data.button.textContent}</span>   
            <span class="bg-popup-button__icon">  
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="18"
                    viewBox="0 0 329.26933 329"
                    width="18" style="width:18px;height:18px;"
                    >
                    <path
                    d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"
                    fill="#ffff"
                    />
                 </svg> 
            </span>
            </button>

            <div id="bg-popup" class="bg-popup bg-popup-container--hidden" style="${data.button.position == 'left' ?'left: 0px;':'right:0px'}">
            <div class="bg-popup-header">
                <div class="bg-popup-title">${data.popup.title}</div>
                <svg onclick="togglePopup()" id="bg-popup__close" class="bg-popup__close" style="width:20px !important;height:20px !important" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M12.4714 4.47132L11.5287 3.52866L8.00002 7.05732L4.47135 3.52866L3.52869 4.47132L7.05735 7.99999L3.52869 11.5287L4.47135 12.4713L8.00002 8.94266L11.5287 12.4713L12.4714 11.5287L8.94269 7.99999L12.4714 4.47132Z" fill="black"/>
                </svg>
            </div>
    
            <div class="bg-popup-search">
                <label for="bg-search-input" class="bg-popup-search__label">${data.popup.description}</label>
                <div class="bg-popup-search__box">
                    <svg class="bg-popup-search__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g clip-path="url(#clip0_801_511)">
                        <path d="M16.0001 15.0573L11.8254 10.8826C12.9098 9.55637 13.443 7.86404 13.3147 6.15568C13.1863 4.44733 12.4062 2.85366 11.1358 1.70432C9.8654 0.554984 8.20183 -0.0620951 6.48919 -0.0192739C4.77656 0.0235473 3.1459 0.722992 1.93451 1.93439C0.723114 3.14578 0.0236694 4.77644 -0.0191518 6.48907C-0.0619731 8.2017 0.555106 9.86528 1.70445 11.1357C2.85379 12.4061 4.44745 13.1862 6.15581 13.3145C7.86416 13.4429 9.5565 12.9097 10.8828 11.8253L15.0574 16L16.0001 15.0573ZM6.66677 12C5.61193 12 4.58079 11.6872 3.70372 11.1011C2.82666 10.5151 2.14308 9.68216 1.73941 8.70762C1.33574 7.73308 1.23012 6.66073 1.43591 5.62616C1.6417 4.5916 2.14965 3.64129 2.89553 2.89541C3.64141 2.14953 4.59172 1.64158 5.62628 1.43579C6.66085 1.23 7.7332 1.33562 8.70774 1.73929C9.68228 2.14295 10.5152 2.82654 11.1013 3.7036C11.6873 4.58066 12.0001 5.61181 12.0001 6.66664C11.9985 8.08064 11.4361 9.43628 10.4362 10.4361C9.4364 11.436 8.08077 11.9984 6.66677 12Z" fill="#616161"/>
                        </g>
                        <defs>
                        <clipPath id="clip0_801_511">
                        <rect width="16" height="16" fill="white"/>
                        </clipPath>
                        </defs>
                    </svg>
                    <input type="text" id="bg-search-input"   onfocus="bgShowPreviousResults()"  class="bg-popup-search__input" oninput="bgDebouncedSearch(this.value)" placeholder="${data.popup.searchPlaceholder}">
                    <div class="bg-popup-search__loader"></div>
                </div>
                <div id="bg-search-results" class="bg-popup-search__results"></div>
            </div>
            
            <div class="bg-featured-nonprofits">
            <div class="bg-featured-nonprofits__header">
                <svg class="bg-featured-nonprofits__icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clip-path="url(#clip0_803_90)">
                <path d="M14.4157 1.06937C14.2966 1.03755 14.2116 0.932673 14.2051 0.809732L14.1917 0.55357C14.1847 0.430907 14.0995 0.326581 13.9806 0.295047C13.8618 0.263513 13.7361 0.311995 13.6691 0.415071L13.5299 0.629557C13.4627 0.733189 13.3363 0.781671 13.2171 0.749303L12.9704 0.68304C12.8508 0.650395 12.7238 0.698877 12.6566 0.802925C12.5892 0.906973 12.5968 1.04256 12.6756 1.13827L12.8363 1.33747C12.8965 1.41235 12.9144 1.51265 12.8838 1.60378L14.521 1.09784L14.4157 1.06937Z" fill="#FFE165"/>
                <path d="M14.6625 1.13522L14.5202 1.09702L12.8838 1.60059C12.8774 1.62434 12.8678 1.64712 12.8554 1.66838L12.7162 1.88259C12.6489 1.98608 12.656 2.12124 12.7337 2.21724C12.8117 2.31309 12.9425 2.34782 13.0577 2.30309L13.2961 2.2114C13.411 2.16695 13.5414 2.2014 13.6192 2.29683L13.7801 2.4959C13.8576 2.59175 13.9879 2.62676 14.103 2.58258C14.2181 2.53841 14.2917 2.42519 14.2853 2.30211L14.272 2.04609C14.2654 1.92301 14.3389 1.80979 14.4539 1.76562L14.6925 1.67393C14.8061 1.62879 14.8783 1.51599 14.8715 1.39388C14.8647 1.27163 14.7805 1.16745 14.6625 1.13522Z" fill="#FFD839"/>
                <path d="M5.19387 1.43068C5.27263 1.33511 5.28041 1.19939 5.21304 1.09534C5.14567 0.991293 5.0187 0.942811 4.89909 0.975595L3.68316 1.30246C3.64593 1.31163 3.60717 1.31302 3.56938 1.30635L1.94879 4.34112L1.93351 4.63909C1.92698 4.76217 2.00047 4.87553 2.11563 4.9197C2.23065 4.96388 2.36123 4.92901 2.43875 4.83302L3.23085 3.85463C3.30864 3.75934 3.43922 3.72488 3.55396 3.76934L4.72933 4.22026C4.8445 4.26499 4.97535 4.23026 5.05315 4.13441C5.13108 4.03856 5.13816 3.90325 5.07065 3.79976L4.38302 2.74289C4.31592 2.63953 4.32287 2.50465 4.40038 2.40879L5.19387 1.43068Z" fill="#FF9811"/>
                <path d="M3.37076 1.18329L2.68521 0.127525C2.61769 0.0254212 2.49239 -0.0219492 2.37431 0.00972373C2.25609 0.0413966 2.17136 0.145028 2.16399 0.267135L2.09676 1.5246C2.09037 1.64782 2.00535 1.75284 1.8863 1.78466L0.670366 2.10986C0.551176 2.14167 0.46602 2.24669 0.45963 2.36977C0.453101 2.49299 0.526727 2.60634 0.641888 2.65038L1.81712 3.1013C1.93214 3.14548 2.00577 3.25883 1.99924 3.38191L1.94881 4.34113L3.5683 1.30637C3.48786 1.29567 3.4159 1.2508 3.37076 1.18329Z" fill="#FFAF46"/>
                <path d="M10.5321 6.11273L8.4321 2.87946C8.29791 2.67261 8.04578 2.57579 7.80754 2.63955C7.5693 2.70345 7.3994 2.91336 7.38662 3.15965L7.18491 7.00985C7.172 7.25587 7.0021 7.46578 6.76414 7.52954L3.04007 8.52737C2.80169 8.591 2.63138 8.8009 2.61846 9.0472C2.60554 9.2935 2.75279 9.52021 2.98312 9.60842L6.58257 10.9899C6.81276 11.0783 6.96001 11.3047 6.94709 11.551L6.76719 14.9786L10.7801 6.31958C10.6789 6.27651 10.5927 6.20456 10.5321 6.11273Z" fill="#FFD839"/>
                <path d="M15.4701 6.26249C15.6248 6.07092 15.6388 5.80156 15.5048 5.59499C15.3707 5.38842 15.119 5.29146 14.8811 5.35495L11.1564 6.35264C11.0309 6.38529 10.8979 6.37362 10.78 6.31958L6.7671 14.9786L6.74446 15.4011C6.7314 15.6474 6.87851 15.874 7.10869 15.9623C7.33902 16.0505 7.5999 15.9806 7.75493 15.7889L10.1811 12.7928C10.3363 12.6012 10.5972 12.5314 10.8272 12.6196L14.4268 14.0014C14.6568 14.0901 14.918 14.0205 15.0733 13.829C15.2286 13.6374 15.2429 13.3676 15.1087 13.1606L13.0085 9.92682C12.8743 9.72011 12.8884 9.45033 13.0435 9.25877L15.4701 6.26249Z" fill="#FFCD00"/>
                </g>
                <defs>
                <clipPath id="clip0_803_90">
                <rect width="16" height="16" fill="white"/>
                </clipPath>
                </defs>
                </svg>
                <div class="bg-featured-nonprofits__title">${data.popup.subTitle}</div>
            </div>
                <div class="bg-featured-nonprofits__list">
                    ${data.popup.nonprofits.map(item => {      
                        let fullName = item.full_name;
                        let initials =  item?.affiliate_type?.type == "You are an organization" ?  item.first_name.slice(0, 2) : (item.first_name.slice(0, 1).toUpperCase() + item.last_name.slice(0,1).toUpperCase());
                        const randomColor = getRandomColor(fullName);
                        return `
                        <div class="bg-featured-nonprofits__item" onclick="selectNonprofit('${item.hash_code}')">
                            <div class="bg-featured-nonprofits__avatar">
                            ${item.avatar 
                                ? `<img src="${item.avatar_link}" alt="${item.full_name}" class="bg-featured-nonprofits__image">` 
                                : `<span class="bg-featured-nonprofits__initials" style="color:${randomColor.color};background: ${randomColor.background}" >${initials}</span>`}
                            </div>
                            <div class="bg-featured-nonprofits__name">${fullName}</div>
                            <div class="bg-featured-nonprofits__info">
                             ${item?.affiliate_type?.type != 'You are an organization' ? `<div class="bg-featured-nonprofits__company">${item.company || ''}</div>` : ''} 
                              <div class="bg-featured-nonprofits__address">${item.city || ''}${item.state?item.city? `, ${item.state}`: item.state:''} 
                              ${item.country && item.country != 'US' ? `${ item.city ||item.state? ", " : ""}${findCountryNameByCode(item.country)}` : ''}
                               </div>
                            </div>
                        </div>
                    `
                    } ).join('')}
                </div>
            </div>
            </div>
        </div>
    `;

  document.body.insertAdjacentHTML("beforeend", popupHTML);
  hideSearchResult();               
}

function applyStyles() {
  const styles = `
    .bg-popup-container {
        position: fixed;
        bottom: 20px;
        z-index: 2147483649;
        font-size: 13px;
        box-sizing: border-box;
    }

    .bg-popup-button {
        height: 50px;
        border: none;
        border-radius: 30px;
        cursor: pointer;
        font-size: 16px;
        font-weight: 500;
        transition: width 0.4s ease-in-out, border-radius 0.4s;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        width: 220px;
        overflow: hidden;
        white-space: nowrap;
        animation: bgFadeIn 0.5s ease-out forwards;
    }

    .bg-popup-button__text, .bg-popup-button__icon{
        position: absolute;
        transition: opacity 0.3s, transform 0.4s;
    }

    .bg-popup-button__icon {
        opacity: 0;
        transform: translateX(20px);
    }

    .bg-popup-container--visible .bg-popup-button {
        width: 50px;
        border-radius: 50%;
    }

    .bg-popup-container--visible .bg-popup-button__text {
        opacity: 0;
        transform: translateX(-20px);
    }

    .bg-popup-container--visible .bg-popup-button__icon {
        opacity: 1;
        transform: translateX(0);
    }

    .bg-popup {
        display: none !important;
        position: absolute;
        bottom: 68px;
        padding: 16px;
        background-color: #FFF;
        color: #111928;
        border-radius: 10px;
        box-shadow: 0px 4px 12px 0px rgba(13, 10, 44, 0.06);
        display: flex;
        flex-direction: column;
        gap: 8px;
        width:360px;
        animation: bgFadeInOut 0.5s ease-in-out forwards;
        max-height: 600px;
    }

    .bg-popup-container--hidden .bg-popup {
        animation: bgFadeOutDown 0.5s ease-in-out forwards;
        pointer-events: none; 
        display: none !important;
    }

    .bg-popup-container--visible .bg-popup {
        display: flex !important;
        animation: bgFadeInUp 0.5s ease-in-out forwards;
    }

    .bg-popup-header{
        display: flex;
        justify-content: space-between;
        gap: 8px;
        align-items:center
    }

    .bg-popup-title{
        font-size: 20px;
        font-weight: 650;
    }

    .bg-popup__close {
        cursor: pointer;
        flex-shrink: 0;
    }

    .bg-popup-search{
        width: 100%;
        position: relative;
    }

    .bg-popup-search__label{
        font-size: 15px;
        font-weight: 450;
        margin-bottom: 6px;
        display: inline-block !important;
    }

    .bg-popup-search__box{
        display: flex;
        padding: 8px 12px;
        align-items: center;
        gap: 8px;
        border-radius: 4px;
        border: 1px solid #E3E3E3;
        background: #FFFFFF;
        overflow: hidden;
        position: relative;
    }

    .bg-popup-search__icon{
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    .bg-popup-search__input {
        flex: 1;
        border: none;
        outline: none;
        font-size: 14px;
        background: transparent;
    }

    .bg-popup-search__input:focus {
        border: none;
        outline: none;
        box-shadow: none;
    }

    .bg-popup-search__loader {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        display: none;
        width: 16px;
        height: 16px;
        border: 2px solid #303030;
        border-top: 2px solid transparent;
        border-radius: 50%;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        0% { transform: translateY(-50%) rotate(0deg); }
        100% { transform: translateY(-50%) rotate(360deg); }
      }

      .bg-popup-search__results{
        position: absolute;
        width: 100%;
        background: white;
        border-radius: 4px;
        display: none;
        max-height: 254px;
        overflow-y: auto;
        padding: 8px;
        box-shadow: 0 8px 16px 0 rgba(0, 0, 0, .2);
        margin-top: 6px;
      }

      .bg-popup-search__item {
        text-overflow: ellipsis;
        display: flex;
        align-items: start;
        gap: 8px;
        font-size: 13px;
        border-left: 1px solid #E3E3E3;
        border-right: 1px solid #E3E3E3;
        border-bottom: 1px solid #E3E3E3;
        background: #FFF;
        padding: 6px 8px;
      }

      .bg-popup-search__item:first-child {
        border-top: 1px solid #E3E3E3;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
    
      .bg-popup-search__item:last-child {
          border-bottom-left-radius: 4px;
          border-bottom-right-radius: 4px;
      }

      .bg-popup-search__item:hover {
          background: #f0f0f0;
          cursor: pointer;
      }

      .bg-popup-search__initials{
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-weight: 700;
        font-size: 8px;
      }

      .bg-popup-search__image{
        width: 40px;
        height: 40px;
        border-radius: 4px;
      }

      .bg-popup-search__name{
        flex: 1 0 0;
        font-weight: 500;
    }

    .bg-popup-search__info{
        color: #616161;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
    }


      .bg-popup-search__no-results {
        padding: 8px;
        text-align: center;
        color: #888;
      }

    .bg-featured-nonprofits{
        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .bg-featured-nonprofits__header{
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .bg-featured-nonprofits__icon{
        width: 16px;
        height: 16px;
        flex-shrink: 0;
    }

    .bg-featured-nonprofits__title{
        font-size: 13px;
    }

    .bg-featured-nonprofits__list{
        display:flex;
        flex-direction: column;
        overflow-y: auto;
        max-height: 288px;
    }

    .bg-featured-nonprofits__item{
        border-left: 1px solid #E3E3E3;
        border-right: 1px solid #E3E3E3;
        border-bottom: 1px solid #E3E3E3;
        background: #FFF;
        padding: 6px 8px;
        display: flex;
        align-items: start;
        gap: 8px;
        font-size: 13px;
    }

    .bg-featured-nonprofits__item:first-child {
        border-top: 1px solid #E3E3E3;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
    }
    
    .bg-featured-nonprofits__item:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    .bg-featured-nonprofits__item:hover {
        background: #f0f0f0;
        cursor: pointer;
    }

    .bg-featured-nonprofits__initials{
        width: 40px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 4px;
        font-weight: 700;
        font-size: 8px;
    }

    .bg-featured-nonprofits__image{
        width: 40px;
        height: 40px; 
        border-radius: 4px;
    }

    .bg-featured-nonprofits__name{
        flex: 1 0 0;
        font-weight: 500;
    }

    .bg-featured-nonprofits__info{
        color: #616161;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
    }

    @keyframes bgFadeInUp {
        0% {
            opacity: 0;
            transform: translateY(20px);
        }
        100% {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @keyframes bgFadeOutDown {
        from {
            opacity: 1;
            transform: translateY(0);
        }
        to {
            opacity: 0;
            transform: translateY(20px); 
        }
    }

    @keyframes bgFadeIn {
        from {
          opacity: 0;
        }
        to {
          opacity: 1;
        }
      }

    @media (max-width: 480px){
        .bg-popup-container--visible{
            bottom: 0;
            left: 0 !important;
            width: 100%;
        }
        .bg-popup-container--visible .bg-popup-button{
            display:none !important;
        }
        .bg-popup-container--visible .bg-popup{
            border-radius: 0px;
            bottom: 0;
            width: 100%;
        }
    }
`;

  const styleSheet = document.createElement("style");
  styleSheet.type = "text/css";
  styleSheet.innerText = styles;
  document.head.appendChild(styleSheet);
}

function hideSearchResult(){
    document.addEventListener("click", function(event) {
        const searchContainer = document.querySelector(".bg-popup-search");
        const resultsBox = document.getElementById("bg-search-results");
        
        if (!searchContainer.contains(event.target)) {
          resultsBox.style.display = "none";
        }
      });
}

function togglePopup() {
    const popupContainer = document.getElementById("bg-popup-container");
    if (popupContainer.classList.contains("bg-popup-container--visible")) {
        closePopup();
    }
    else{
        openPopup();
     }
}

function openPopup(){
  const popupContainer = document.getElementById("bg-popup-container");
  popupContainer.classList.add("bg-popup-container--visible");
  popupContainer.classList.remove("bg-popup-container--hidden");
}

function closePopup() {
    const popupContainer = document.getElementById("bg-popup-container");
    const resultsBox = document.getElementById("bg-search-results");
    const loader = document.querySelector(".bg-popup-search__loader");
    const searchInput = document.getElementById("bg-search-input");

    popupContainer.classList.remove("bg-popup-container--visible");
    popupContainer.classList.add("bg-popup-container--hidden");
    resultsBox.innerHTML = "";
    resultsBox.style.display = "none";
    loader.style.display = "none";
    searchInput.value = "";
  }

function bgDebounce(fn, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => fn.apply(this, args), delay);
    };
  }

  function bgFetchSearchResults(query) {
    const loader = document.querySelector(".bg-popup-search__loader");
    const resultsBox = document.getElementById("bg-search-results");

    if (!query.trim()){
        resultsBox.style.display = "none";
        return;
    } 
    loader.style.display = "inline-block";

    const payload = {
        shop: Shopify.shop,
        q: query
    }

    bgUseFetch(`${BIXGROW_API_URL}/shop/custom-popup/search-affiliate`,'GET',payload).then(data => {
        loader.style.display = "none";
        resultsBox.innerHTML = "";
        if (data.length > 0) {
            let htmlContent = "";
            data.forEach(item => {
              let fullName = item.full_name;
              let initials = item?.affiliate_type?.type == 'You are an organization' ? item.first_name.slice(0, 2) : (item.first_name.slice(0, 1).toUpperCase() + item.last_name.slice(0,1).toUpperCase());
              const randomColor = getRandomColor(fullName);
                htmlContent += 
                `<div class="bg-popup-search__item" onclick="selectNonprofit('${item.hash_code}')">
                      <div class="bg-popup-search__avatar">
                      ${item.avatar 
                          ? `<img src="${item.avatar_link}" alt="${fullName}" class="bg-popup-search__image">` 
                          : `<span class="bg-popup-search__initials" style="color:${randomColor.color};background: ${randomColor.background}" >${initials}</span>`}
                      </div>
                      <div class="bg-popup-search__name">${fullName}</div>
                      <div class="bg-popup-search__info">
                       ${item?.affiliate_type?.type != 'You are an organization' ? `<div class="bg-popup-search__company">${item.company || ''}</div>` :''} 
                        <div class="bg-popup-search__address">${item.city || ''}${item.state?item.city? `, ${item.state}`: item.state:''}
                        ${item.country && item.country != 'US' ? `${ item.city ||item.state? ", " : ""}${findCountryNameByCode(item.country)}` : ''}
                        </div>
                      </div>
                  </div>`;
            });
            resultsBox.innerHTML = htmlContent;
            } else {
                resultsBox.innerHTML = '<div class="bg-popup-search__no-results">No results found</div>';
            }
          resultsBox.style.display = "block";
    })  .catch(error => {
        console.error("Lỗi API:", error);
        loader.style.display = "none";
        resultsBox.innerHTML = '<div class="bg-popup-search__no-results">Error fetching results</div>';
        resultsBox.style.display = "block";
    });
  }

  function bgShowPreviousResults(){
    const input = document.getElementById("bg-search-input");
    const resultsBox = document.getElementById("bg-search-results");

    if (input.value.trim()) {
        if (resultsBox.innerHTML.trim()) {
            resultsBox.style.display = "block";
        }
    }
  }

  // Gán debounce cho hàm fetchSearchResults
const bgDebouncedSearch = bgDebounce(bgFetchSearchResults, 400);

function selectNonprofit(hashCode){
    if (typeof getStoreToolBars === "function") {
        getStoreToolBars(hashCode);
        handleClick(hashCode);
        closePopup();
    } else {
        console.error("getStoreToolBars is not defined!");
    }
}

function handleClick(bgRefCode){
    let bgVisitorId = bgGetCookie("bgvisitor_id");
    let affiliateId = bgGetCookie("bgaffilite_id");
    let lastClick = bgGetCookie("bglast_click");
    let destinationUrl = (() => {
        let url = new URL(window.location.href);
        url.searchParams.set("bg_ref", bgRefCode);
        return url.toString();
      })();

    if (bgRefCode) {
        if (bgVisitorId === "") {
          console.log(1);
          let payload = {
            aff_id: bgRefCode,
            event_type: "click",
            referral_site: document.referrer,
            destination_url: destinationUrl,
          };
          bgPostEvent(payload);
        } else {
          if (affiliateId != bgRefCode) {
            console.log(2);
            let payload = {
              aff_id: bgRefCode,
              visitor_id: bgVisitorId,
              event_type: "click",
              referral_site: document.referrer,
              destination_url: destinationUrl,
            };
            bgPostEvent(payload);
          } else {
            if (new Date().getTime() - lastClick > 60 * 1000) {
              console.log(3);
              let payload = {
                aff_id: bgRefCode,
                visitor_id: bgVisitorId,
                event_type: "click",
                referral_site: document.referrer,
                destination_url: destinationUrl,
              };
              bgPostEvent(payload);
            }
          }
        }
      }
}

async function bgPostEvent(data) {
    const apiURl = `${BASE_TRACK_URL}/bg_trackv2`;
    
    try {
      const response = await fetch(apiURl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        console.log("Bixgrow - network response was not ok");
      }

      const responseData = await response.json();
      if (
        responseData.event_type == "click" &&
        typeof responseData.visitor_id !== "undefined"
      ) {
        bgSetCookieByUnixTime(
          "bgvisitor_id",
          responseData.visitor_id,
          responseData.expire_at
        );
        bgSetCookieByUnixTime(
          "bgaffilite_id",
          data.aff_id,
          responseData.expire_at
        );
        bgSetCookieByUnixTime(
          "bglast_click",
          new Date().getTime(),
          responseData.expire_at
        );
        bgSetCookieByUnixTime(
          "bgexpire_time",
          responseData.expire_at,
          responseData.expire_at
        );
        bgSetCookieByUnixTime(
          "bgclick_id",
          responseData.click_id,
          responseData.expire_at
        );
      } 
    } catch (error) {
      console.error("Bixgrow - error:", error);
    }
  }

  function bgGetCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function bgSetCookieByUnixTime(cname, cvalue, unixTime) {
    var d = new Date(unixTime * 1000);
    var expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getRandomColor (text) {
    const colors = [
        { background: "#FBCFFB", color: "#791A79" },
        { background: "#CFFBF3", color: "#19796A" },
        { background: "#FBFBCF", color: "#79791A" },
        { background: "#CFCFFB", color: "#1A1A79" },
        { background: "#FBCFCF", color: "#791A1A" }
    ];

    if (!text) return colors[0]; 

    const firstChar = text.charAt(0).toUpperCase(); 
    const index = firstChar.charCodeAt(0) % colors.length; 

    return colors[index];
};

async function bgUseFetch(url, method = "GET",params = null,headers = { "Content-Type": "application/json"} ){
  try {
    const options = {
      method: method,
      headers: {
        ...headers
      }
    }
    if(params){
      if(method == 'GET'){
        const queryString = new URLSearchParams(params).toString();
        url += '?' + queryString;
      }else{
        options.body = JSON.stringify(params);
      }
    }
    const response = await fetch(url,options);
    if(!response.ok){
      throw new Error(response.statusText);
    }
    const responseData = await response.json().catch(() => null);
    if(responseData){
      return responseData;
    }else{
      return null;
    }
  } catch (error) {
     return null;
  }
  
}

const findCountryNameByCode = code => BG_COUNTRIES.find(country => country.id == code)?.name;

const BG_COUNTRIES = [
  { name: "Afghanistan", id: "AF" },
  { name: "land Islands", id: "AX" },
  { name: "Albania", id: "AL" },
  { name: "Algeria", id: "DZ" },
  { name: "American Samoa", id: "AS" },
  { name: "AndorrA", id: "AD" },
  { name: "Angola", id: "AO" },
  { name: "Anguilla", id: "AI" },
  { name: "Antarctica", id: "AQ" },
  { name: "Antigua and Barbuda", id: "AG" },
  { name: "Argentina", id: "AR" },
  { name: "Armenia", id: "AM" },
  { name: "Aruba", id: "AW" },
  { name: "Australia", id: "AU" },
  { name: "Austria", id: "AT" },
  { name: "Azerbaijan", id: "AZ" },
  { name: "Bahamas", id: "BS" },
  { name: "Bahrain", id: "BH" },
  { name: "Bangladesh", id: "BD" },
  { name: "Barbados", id: "BB" },
  { name: "Belarus", id: "BY" },
  { name: "Belgium", id: "BE" },
  { name: "Belize", id: "BZ" },
  { name: "Benin", id: "BJ" },
  { name: "Bermuda", id: "BM" },
  { name: "Bhutan", id: "BT" },
  { name: "Bolivia", id: "BO" },
  { name: "Bosnia and Herzegovina", id: "BA" },
  { name: "Botswana", id: "BW" },
  { name: "Bouvet Island", id: "BV" },
  { name: "Brazil", id: "BR" },
  { name: "British Indian Ocean Territory", id: "IO" },
  { name: "Brunei Darussalam", id: "BN" },
  { name: "Bulgaria", id: "BG" },
  { name: "Burkina Faso", id: "BF" },
  { name: "Burundi", id: "BI" },
  { name: "Cambodia", id: "KH" },
  { name: "Cameroon", id: "CM" },
  { name: "Canada", id: "CA" },
  { name: "Cape Verde", id: "CV" },
  { name: "Cayman Islands", id: "KY" },
  { name: "Central African Republic", id: "CF" },
  { name: "Chad", id: "TD" },
  { name: "Chile", id: "CL" },
  { name: "China", id: "CN" },
  { name: "Christmas Island", id: "CX" },
  { name: "Cocos (Keeling) Islands", id: "CC" },
  { name: "Colombia", id: "CO" },
  { name: "Comoros", id: "KM" },
  { name: "Congo", id: "CG" },
  { name: "Congo, The Democratic Republic of the", id: "CD" },
  { name: "Cook Islands", id: "CK" },
  { name: "Costa Rica", id: "CR" },
  { name: 'Cote D"Ivoire', id: "CI" },
  { name: "Croatia", id: "HR" },
  { name: "Cuba", id: "CU" },
  { name: "Cyprus", id: "CY" },
  { name: "Czech Republic", id: "CZ" },
  { name: "Denmark", id: "DK" },
  { name: "Djibouti", id: "DJ" },
  { name: "Dominica", id: "DM" },
  { name: "Dominican Republic", id: "DO" },
  { name: "Ecuador", id: "EC" },
  { name: "Egypt", id: "EG" },
  { name: "El Salvador", id: "SV" },
  { name: "Equatorial Guinea", id: "GQ" },
  { name: "Eritrea", id: "ER" },
  { name: "Estonia", id: "EE" },
  { name: "Ethiopia", id: "ET" },
  { name: "Falkland Islands (Malvinas)", id: "FK" },
  { name: "Faroe Islands", id: "FO" },
  { name: "Fiji", id: "FJ" },
  { name: "Finland", id: "FI" },
  { name: "France", id: "FR" },
  { name: "French Guiana", id: "GF" },
  { name: "French Polynesia", id: "PF" },
  { name: "French Southern Territories", id: "TF" },
  { name: "Gabon", id: "GA" },
  { name: "Gambia", id: "GM" },
  { name: "Georgia", id: "GE" },
  { name: "Germany", id: "DE" },
  { name: "Ghana", id: "GH" },
  { name: "Gibraltar", id: "GI" },
  { name: "Greece", id: "GR" },
  { name: "Greenland", id: "GL" },
  { name: "Grenada", id: "GD" },
  { name: "Guadeloupe", id: "GP" },
  { name: "Guam", id: "GU" },
  { name: "Guatemala", id: "GT" },
  { name: "Guernsey", id: "GG" },
  { name: "Guinea", id: "GN" },
  { name: "Guinea-Bissau", id: "GW" },
  { name: "Guyana", id: "GY" },
  { name: "Haiti", id: "HT" },
  { name: "Heard Island and Mcdonald Islands", id: "HM" },
  { name: "Holy See (Vatican City State)", id: "VA" },
  { name: "Honduras", id: "HN" },
  { name: "Hong Kong", id: "HK" },
  { name: "Hungary", id: "HU" },
  { name: "Iceland", id: "IS" },
  { name: "India", id: "IN" },
  { name: "Indonesia", id: "ID" },
  { name: "Iran, Islamic Republic Of", id: "IR" },
  { name: "Iraq", id: "IQ" },
  { name: "Ireland", id: "IE" },
  { name: "Isle of Man", id: "IM" },
  { name: "Israel", id: "IL" },
  { name: "Italy", id: "IT" },
  { name: "Jamaica", id: "JM" },
  { name: "Japan", id: "JP" },
  { name: "Jersey", id: "JE" },
  { name: "Jordan", id: "JO" },
  { name: "Kazakhstan", id: "KZ" },
  { name: "Kenya", id: "KE" },
  { name: "Kiribati", id: "KI" },
  { name: 'Korea, Democratic People"S Republic of', id: "KP" },
  { name: "Korea, Republic of", id: "KR" },
  { name: "Kuwait", id: "KW" },
  { name: "Kyrgyzstan", id: "KG" },
  { name: 'Lao People"S Democratic Republic', id: "LA" },
  { name: "Latvia", id: "LV" },
  { name: "Lebanon", id: "LB" },
  { name: "Lesotho", id: "LS" },
  { name: "Liberia", id: "LR" },
  { name: "Libyan Arab Jamahiriya", id: "LY" },
  { name: "Liechtenstein", id: "LI" },
  { name: "Lithuania", id: "LT" },
  { name: "Luxembourg", id: "LU" },
  { name: "Macao", id: "MO" },
  { name: "Macedonia, The Former Yugoslav Republic of", id: "MK" },
  { name: "Madagascar", id: "MG" },
  { name: "Malawi", id: "MW" },
  { name: "Malaysia", id: "MY" },
  { name: "Maldives", id: "MV" },
  { name: "Mali", id: "ML" },
  { name: "Malta", id: "MT" },
  { name: "Marshall Islands", id: "MH" },
  { name: "Martinique", id: "MQ" },
  { name: "Mauritania", id: "MR" },
  { name: "Mauritius", id: "MU" },
  { name: "Mayotte", id: "YT" },
  { name: "Mexico", id: "MX" },
  { name: "Micronesia, Federated States of", id: "FM" },
  { name: "Moldova, Republic of", id: "MD" },
  { name: "Monaco", id: "MC" },
  { name: "Mongolia", id: "MN" },
  { name: "Montenegro", id: "ME" },
  { name: "Montserrat", id: "MS" },
  { name: "Morocco", id: "MA" },
  { name: "Mozambique", id: "MZ" },
  { name: "Myanmar", id: "MM" },
  { name: "Namibia", id: "NA" },
  { name: "Nauru", id: "NR" },
  { name: "Nepal", id: "NP" },
  { name: "Netherlands", id: "NL" },
  { name: "Netherlands Antilles", id: "AN" },
  { name: "New Caledonia", id: "NC" },
  { name: "New Zealand", id: "NZ" },
  { name: "Nicaragua", id: "NI" },
  { name: "Niger", id: "NE" },
  { name: "Nigeria", id: "NG" },
  { name: "Niue", id: "NU" },
  { name: "Norfolk Island", id: "NF" },
  { name: "Northern Mariana Islands", id: "MP" },
  { name: "Norway", id: "NO" },
  { name: "Oman", id: "OM" },
  { name: "Pakistan", id: "PK" },
  { name: "Palau", id: "PW" },
  { name: "Palestinian Territory, Occupied", id: "PS" },
  { name: "Panama", id: "PA" },
  { name: "Papua New Guinea", id: "PG" },
  { name: "Paraguay", id: "PY" },
  { name: "Peru", id: "PE" },
  { name: "Philippines", id: "PH" },
  { name: "Pitcairn", id: "PN" },
  { name: "Poland", id: "PL" },
  { name: "Portugal", id: "PT" },
  { name: "Puerto Rico", id: "PR" },
  { name: "Qatar", id: "QA" },
  { name: "Reunion", id: "RE" },
  { name: "Romania", id: "RO" },
  { name: "Russian Federation", id: "RU" },
  { name: "RWANDA", id: "RW" },
  { name: "Saint Helena", id: "SH" },
  { name: "Saint Kitts and Nevis", id: "KN" },
  { name: "Saint Lucia", id: "LC" },
  { name: "Saint Pierre and Miquelon", id: "PM" },
  { name: "Saint Vincent and the Grenadines", id: "VC" },
  { name: "Samoa", id: "WS" },
  { name: "San Marino", id: "SM" },
  { name: "Sao Tome and Principe", id: "ST" },
  { name: "Saudi Arabia", id: "SA" },
  { name: "Senegal", id: "SN" },
  { name: "Serbia", id: "RS" },
  { name: "Seychelles", id: "SC" },
  { name: "Sierra Leone", id: "SL" },
  { name: "Singapore", id: "SG" },
  { name: "Slovakia", id: "SK" },
  { name: "Slovenia", id: "SI" },
  { name: "Solomon Islands", id: "SB" },
  { name: "Somalia", id: "SO" },
  { name: "South Africa", id: "ZA" },
  { name: "South Georgia and the South Sandwich Islands", id: "GS" },
  { name: "Spain", id: "ES" },
  { name: "Sri Lanka", id: "LK" },
  { name: "Sudan", id: "SD" },
  { name: "Surname", id: "SR" },
  { name: "Svalbard and Jan Mayen", id: "SJ" },
  { name: "Swaziland", id: "SZ" },
  { name: "Sweden", id: "SE" },
  { name: "Switzerland", id: "CH" },
  { name: "Syrian Arab Republic", id: "SY" },
  { name: "Taiwan, Province of China", id: "TW" },
  { name: "Tajikistan", id: "TJ" },
  { name: "Tanzania, United Republic of", id: "TZ" },
  { name: "Thailand", id: "TH" },
  { name: "Timor-Leste", id: "TL" },
  { name: "Togo", id: "TG" },
  { name: "Tokelau", id: "TK" },
  { name: "Tonga", id: "TO" },
  { name: "Triidd and Tobago", id: "TT" },
  { name: "Tunisia", id: "TN" },
  { name: "Turkey", id: "TR" },
  { name: "Turkmenistan", id: "TM" },
  { name: "Turks and Caicos Islands", id: "TC" },
  { name: "Tuvalu", id: "TV" },
  { name: "Uganda", id: "UG" },
  { name: "Ukraine", id: "UA" },
  { name: "United Arab Emirates", id: "AE" },
  { name: "United Kingdom", id: "GB" },
  { name: "United States", id: "US" },
  { name: "United States Minor Outlying Islands", id: "UM" },
  { name: "Uruguay", id: "UY" },
  { name: "Uzbekistan", id: "UZ" },
  { name: "Vanuatu", id: "VU" },
  { name: "Venezuela", id: "VE" },
  { name: "Viet Nam", id: "VN" },
  { name: "Virgin Islands, British", id: "VG" },
  { name: "Virgin Islands, U.S.", id: "VI" },
  { name: "Wallis and Futuna", id: "WF" },
  { name: "Western Sahara", id: "EH" },
  { name: "Yemen", id: "YE" },
  { name: "Zambia", id: "ZM" },
  { name: "Zimbabwe", id: "ZW" }
];

console.log("Select affiliate floating widget JS has been loaded.")
